import React from 'react';
import { Dialog, DialogTitle, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Button from '../../components/Button';

function EmailFindModal(props) {
  const {
    history,
    open,
    onClose,
    classes: { modal },
  } = props;

  const login = () => {
    localStorage.setItem('pathUrl', JSON.stringify(history.location));
    history.push('/login?redirect=pathUrl');
  };

  return (
    <>
      <Dialog
        fullWidth
        // disableBackdropClick={true}
        open={open}
        onClose={onClose}
        classes={{ paper: modal }}
        maxWidth={'xl'}
      >
        <DialogTitle>
          <Grid container alignItems="center">
            <Grid className="headingText emaiText" item xs={12}>
              <h1>Login</h1>
            </Grid>
            <Grid className="emaiText" item xs={12}>
              This email is already in use so please login to continue...
            </Grid>
            <Grid container alignItems="center">
              <Grid className="signInCancelBtn" item xs={12}>
                <Button color="primary" variant="contained" onClick={login}>
                  Log In
                </Button>
                {/* <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={onClose}
                                >
                                    Cancel
                            </Button> */}
              </Grid>
            </Grid>
          </Grid>
        </DialogTitle>
      </Dialog>
    </>
  );
}

const styles = () => ({
  modal: {
    maxHeight: '700px',
    height: 'auto',
    maxWidth: '42% !important',
  },
  modalContent: {
    overflow: 'visible',
  },
  actions: {
    marginTop: '1em',
  },
  input: {
    margin: '0.5em 0',
  },
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
  previewImg: {
    maxWidth: 300,
    maxHeight: 300,
  },
});

export default withStyles(styles)(EmailFindModal);
